export default "__VITE_ASSET__Ds9esw1q__"